module.exports = __webpack_public_path__ + "img/73c04a9d85343ff127472472790cf9cc.2bd52198.jpg";